/* eslint-disable no-unused-vars */
import Highcharts from 'highcharts'
import { HighchartsReact } from 'highcharts-react-official'
import React from 'react'

const PieChart = ({ data, series }) => {
  const options = {
    chart: {
      type: 'pie',
      height: 200,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y:.2f}</b>',
      valueDecimals: 2,
      valuePrefix: 'R$',
      valueSuffix: ' BRL',
    },
    title: {
      text: null,
    },

    plotOptions: {
      pie: {
        innerSize: '70%', // Isso cria o buraco no meio, tornando-o um gráfico de rosca
        dataLabels: {
          distance: 2, // Ajuste este valor conforme necessário
        },
      },
    },

    series: [
      {
        name: series,
        data: data,
      },
    ],
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export default PieChart
